import { container } from "tsyringe";
import { PickupCorporateConfigApiRepository } from "../repositories/api/PickupCorporateConfigApiRepository";
import ApiService from "../services/ApiService";
import { PickupCorporateConfigMapper } from "@/data/persistences/mappers/PickupCorporateConfigMapper";
import { PickupCorporateConfigEndpoint } from "../endpoints/horde/PickupCorporateConfigEndpoint";
import { PickupCorporateConfigPresenter } from "@/app/ui/presenters/PickupCorporateConfigPresenter";

export class PickupCorporateConfigComponent {
  public static init() {
    container.register<PickupCorporateConfigApiRepository>(
      PickupCorporateConfigApiRepository,
      {
        useFactory: (d) => {
          return new PickupCorporateConfigApiRepository(
            d.resolve(ApiService),
            d.resolve(PickupCorporateConfigMapper),
            d.resolve(PickupCorporateConfigEndpoint)
          );
        }
      }
    );
    container.register<PickupCorporateConfigMapper>(
      PickupCorporateConfigMapper,
      {
        useClass: PickupCorporateConfigMapper
      }
    );
    container.register<PickupCorporateConfigPresenter>(
      PickupCorporateConfigPresenter,
      {
        useFactory: (d) => {
          return new PickupCorporateConfigPresenter(
            d.resolve(PickupCorporateConfigApiRepository)
          );
        }
      }
    );
  }
}
